export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates a single address or a comma-separated list of them.
 *
 * Client correspondence fields accept several recipients, so each token is
 * checked individually rather than the whole string being rejected for
 * containing commas.
 *
 * @example isValidEmailList('a@b.com, c@d.com') // true
 */
export const isValidEmailList = (value: string): boolean => {
    const addresses = value.split(',').map(address => address.trim()).filter(Boolean);
    return addresses.length > 0 && addresses.every(address => EMAIL_REGEX.test(address));
};

/**
 * Indian 10-digit or international format, with spaces, dashes and parens ignored.
 *
 * @example isValidPhoneNumber('+1 (415) 555-2671') // true
 */
export const isValidPhoneNumber = (value: string): boolean =>
    /^(?:\+|0)?\d{7,15}$/.test(value.replace(/[\s\-()]/g, ''));

/**
 * Trims whitespace around each comma-separated address and rejoins with ", ".
 * Drops empty entries left by stray/trailing commas.
 *
 * @example normalizeEmailList('a@b.com ,  c@d.com ,') // 'a@b.com, c@d.com'
 */
export const normalizeEmailList = (value: string): string =>
    value.split(',').map(address => address.trim()).filter(Boolean).join(', ');
